<script setup lang="ts">
const translate = (key: string) => {
	try {
		const nuxtApp = useNuxtApp()
		const i18n = nuxtApp.$i18n as
			| { t?: (value: string) => string; global?: { t?: (value: string) => string } }
			| undefined

		if (typeof i18n?.t === 'function') return i18n.t(key)
		if (typeof i18n?.global?.t === 'function') return i18n.global.t(key)
	} catch {}
	return key
}

let localePath: (path: string) => string
try {
	localePath = useLocalePath()
} catch {
	localePath = (path: string) => path
}
const error = useError()

const statusCode = computed(() => error.value?.statusCode ?? 500)
const isNotFound = computed(() => statusCode.value === 404)

const title = computed(() => {
	return isNotFound.value ? translate('Page Not Found') : translate('Something went wrong')
})

const buttonLabel = computed(() => {
	return isNotFound.value ? translate('Go back home') : translate('Try again')
})

const handleError = () => {
	clearError({ redirect: localePath('/') })
}

const getImage = computed(() => 'lucky_pot.webp')

if (import.meta.client) {
	console.error('[error.vue]', error.value)
}
</script>

<template>
	<main class="bg-secondary-700 h-screen">
		<div class="py-40 text-neutral-50 flex flex-col items-center gap-7">
			<NuxtImg
				:src="`/cdn/${getImage}`"
				alt="Image empty"
				width="168"
				height="168"
				loading="lazy"
				title="Image empty"
				class="w-28 smm:w-44"
			/>

			<div class="space-y-3 text-center">
				<h1 class="text-2xl font-bold">{{ title }}</h1>

				<p
					v-if="!isNotFound"
					class="text-sm opacity-80"
				>
					{{ error?.message || translate('An unexpected error occurred') }}
				</p>

				<UButton
					size="lg"
					variant="outline"
					:label="buttonLabel"
					@click="handleError"
				/>
			</div>
		</div>
	</main>
</template>
